(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lightbox"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function() {

    var lightboxHTML = $('.lightbox__content').html();
    var lightboxDisplay = $('.lightbox__display').val();

    $('html').append('<div class="lightbox__overlay hide-me"></div>');
    $('html').append('<div class="lightbox__wrapper hide-me">' + lightboxHTML + '</div>');

    $('.lightbox__close, .lightbox__overlay').on('click', function(e) {
        e.preventDefault();
        $('.lightbox__overlay').addClass('hide-me');
        $('.lightbox__wrapper').addClass('hide-me');
        $('html').removeClass('lightbox-opened');
    });

    $('.open-popup-link').on('click', function(e) {
        e.preventDefault();
        openLightbox();
    });

  function openLightbox() {
    $('.lightbox__overlay').removeClass('hide-me');
    $('.lightbox__wrapper').removeClass('hide-me');
    $('html').addClass('lightbox-opened');
  }

 
  
  if(lightboxDisplay == 'show') {
     const myTimeout = setTimeout(toggleLightbox, 1500);
     function toggleLightbox() {
        openLightbox();
        clearTimeout(myTimeout);
      }
  }
  
 
  
});


  } catch(e) { console.error(e); }
})();
})();
